import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GoNavigationComponent } from '../shared/components/go-navigation/go-navigation.component';
import { ContactConstants } from '../../../../core/constants/contact-constants';
import { ExternalLinks } from '../../../../core/constants/external-links';

@Component({
    selector: 'app-go-help',
    templateUrl: './go-help.component.html',
    styleUrls: ['./go-help.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GoNavigationComponent],
})
export class GoHelpComponent {
    phoneNumber = ContactConstants.phoneNumber;
    email = ContactConstants.email;
    externalLinks = ExternalLinks.enterpriseWireless;
}
